// removed by extract-text-webpack-plugin
module.exports = {"phoneBlock":"u-naiX2RPM70DOKA8_irG","phoneMask":"_1eamiav2_uHgqaNX0wJmoQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/HeaderPhones/HeaderPhones.scss
// module id = 1569
// module chunks = 0